<template>
  <v-dialog v-model="followsInfoDialog" width="800">
    <v-card>
      <v-toolbar flat>
        <v-spacer></v-spacer>
        <span class="display-1 text-uppercase font-weight-bold">{{$t('infoDialogs.private.follows.Title')}}</span>
        <v-spacer></v-spacer>
        <v-btn color="error" :title="$t('infoDialogs.private.follows.Close window')" class="ma-2" outlined icon large @click="closeDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <p class="pr-5 text--primary title">{{$t('infoDialogs.private.follows.PageDescription')}}.</p>
        <v-divider></v-divider>
        <v-divider></v-divider>
        <v-row>
          <v-col md="12" class="pt-10">
            <span class="body-1 text--primary font-weight-bold">{{$t('infoDialogs.private.follows.PageActionsOne')}}</span>
            <span><v-btn class="error ml-5">{{$t('infoDialogs.private.follows.Unfollow')}}</v-btn></span>
          </v-col>
          <v-col md="12">
            <span class="body-1 text--primary font-weight-bold">{{$t('infoDialogs.private.follows.PageActionsTwo')}}</span>
            <span class="text--primary title font-weight-bold ml-5" style="cursor: pointer; border-bottom:1px solid black;">{{$t('infoDialogs.private.follows.ExampleFollowing')}}</span>
          </v-col>
          <v-col md="12">
            <span class="body-1 text--primary font-weight-bold">{{$t('infoDialogs.private.follows.PageActionsThree')}}</span>
            <span class="text--primary title font-weight-bold ml-5" style="cursor: pointer; border-bottom:1px solid black;">{{$t('infoDialogs.private.follows.ExampleFollowers')}}</span>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
// Import the i18n - This may need to be modified
import messages from "../../modules/lang/export";
export default {
  // Communicate with i18n
  i18n: { messages },
  data(){
    return{
      // Define the dialog v-model that we are using
      followsInfoDialog:false,
    }
  },
  methods: {
    // Opening the dialog through the ref
    openDialog() {
      this.followsInfoDialog = true;
    },
    // Close the dialog
    closeDialog() {
      this.followsInfoDialog = false;
    }
  }
}
</script>